import React from "react";
import "./stepPage.css";
import CancelledSteps from "./cancelStep";
import DefaultSteps from "./defaultStep";

interface ProgressBarProps {
  currentStep: string | null;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ currentStep }) => {
  const defaultSteps = [
    "Created",
    "Confirmed",
    "Pickup In Process",
    "Ready For Payment",
    "Order Pickedup",
  ];
  const cancelledSteps = ["Created", "Cancelled"];

  const isCancelled = currentStep === "Cancelled";
  const steps = isCancelled ? cancelledSteps : defaultSteps;
  const createCompositeStep = ['Confirmation from Customer' , 'Created', "Pending for Partner Confirmation"]
  const fourthStep = ['Paid' , 'Invoiced', 'Ready For Payment']

  // Composite steps logic
  const compositeSteps = ["Pickup In Process", "Assigned", "Evaluation In Process"];
  let currentStepNumber = 0;

  if (isCancelled) {
    currentStepNumber = cancelledSteps.indexOf(currentStep!) + 1;
  } else if(createCompositeStep.includes(currentStep!)){
    currentStepNumber = 1;
  }else if (compositeSteps.includes(currentStep!)) {
    currentStepNumber = 3; // Third step for composite statuses
  }else if (fourthStep.includes(currentStep!)) {
    currentStepNumber = 4; // Third step for composite statuses
  } else {
    currentStepNumber = steps.indexOf(currentStep!) + 1;
  }

  // Automatically tick the 5th step if the 4th is completed
  // if (currentStep === "Ready For Payment") {
  //   currentStepNumber = 5;
  // }

  return (
    <div className="daikin-progressbar">
      <div className="daikin-container">
        <div className="daikin-row">
          {isCancelled ? (
            <CancelledSteps steps={cancelledSteps} currentStepNumber={currentStepNumber} />
          ) : (
            <DefaultSteps steps={defaultSteps} currentStepNumber={currentStepNumber} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
